import React from 'react';
import { FloatingLabel, WrapperContainer } from './Styles';

interface InputWrapperProps {
  id: string;
  label: string;
  required?: boolean;
  children: React.ReactNode;
  value: string;
  isFocused?: boolean;
}

const InputWrapper: React.FC<InputWrapperProps> = ({
  id,
  label,
  required = false,
  children,
  value = '',
  isFocused = false,
}) => {
  const isFloating = Boolean(value) || isFocused;

  return (
    <WrapperContainer>
      {children}
      <FloatingLabel htmlFor={id} isFloating={isFloating}>
        {label} {required && '*'}
      </FloatingLabel>
    </WrapperContainer>
  );
};

export default InputWrapper;
